import { render, staticRenderFns } from "./MenuList.vue?vue&type=template&id=693bdb86&scoped=true&"
import script from "./MenuList.vue?vue&type=script&lang=ts&"
export * from "./MenuList.vue?vue&type=script&lang=ts&"
import style0 from "./MenuList.vue?vue&type=style&index=0&id=693bdb86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "693bdb86",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
installComponents(component, {VList})
